import { render, staticRenderFns } from "./DomicilioSimple.vue?vue&type=template&id=cd61a402"
import script from "./DomicilioSimple.vue?vue&type=script&lang=js"
export * from "./DomicilioSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports